import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HtmlScapePipe } from './html-scape.pipe';
import { BooleanPipe } from './boolean.pipe';
import { DocumentNamePipe } from './document-name.pipe';
import { BytesPipe } from './bytes.pipe';

@NgModule({
  declarations: [HtmlScapePipe, BooleanPipe, DocumentNamePipe, BytesPipe],
  imports: [CommonModule],
  exports: [HtmlScapePipe, BooleanPipe, DocumentNamePipe, BytesPipe]
})
export class PipesModule {}
